export default __webpack_public_path__ + "media/images/projekktor-maccaco/start-baf8d23fc7d00bb3a5a7fd605039abd0.png";